import TtamDynamicDestinationSwitch from './switch/index.vue';
import TtamDynamicDestinationSwitchTips from './tips/index.vue';
import TtamDynamicDestinationErrorTips from './error-tips/index.vue';
import * as Hooks from './hooks';

export default {
  TtamDynamicDestinationSwitch,
  TtamDynamicDestinationSwitchTips,
  TtamDynamicDestinationErrorTips,
  ...Hooks,
};
